import { render, staticRenderFns } from "./bankcashbook.vue?vue&type=template&id=63a30ede&scoped=true"
import script from "./bankcashbook.vue?vue&type=script&lang=js"
export * from "./bankcashbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a30ede",
  null
  
)

export default component.exports